import { useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import styles from "./Writing.module.css";
import { ALL_POSTS } from "./posts/posts";
import PostRow from "../components/PostRow";

const FILTERS = ["all", "craft", "evals", "observability", "context"];

export default function Writing() {
  const [active, setActive] = useState("all");
  const posts = ALL_POSTS.filter((p) =>
    active === "all" ? true : p.tags.includes(active),
  );

  return (
    <div className={styles.page}>
      <Nav theme="light" />

      <div className={styles.container}>
        {/* Page hero */}
        <div className={styles.pageHero}>
          <p className={styles.eyebrow}>// writing</p>
          <h1 className={styles.pageTitle}>
            Things I've learned
            <br />
            <em>shipping LLM systems.</em>
          </h1>
          {/*<p className={styles.pageSub}>
            Writing about what it actually takes to ship LLM systems.
          </p>*/}
        </div>

        {/* Filters */}
        <div className={styles.filters}>
          {FILTERS.map((f) => (
            <button
              key={f}
              className={`${styles.filterBtn} ${active === f ? styles.filterOn : ""}`}
              onClick={() => setActive(f)}
            >
              {f}
            </button>
          ))}
        </div>

        {/* Post list */}
        <div className={styles.postList}>
          {posts.map((post) => (
            <PostRow key={post.slug} post={post} />
          ))}
        </div>

        <Footer theme="light" />
      </div>
    </div>
  );
}
